import React from 'react';
import useWidthSetter from '../../CustomHooks/useWidthSetter';

const FullWidthVideo = ({ vidLink, vidLinkM, caption }) => {
  const userWidth = useWidthSetter();
  return (
    <div className="fullWidthVid">
      <video playsInline muted autoPlay width="320" height="240">
        <source src={userWidth <= 768 ? vidLinkM : vidLink} type="video/mp4" />
      </video>
      <p>{caption}</p>
    </div>
  );
};

export default FullWidthVideo;
